export default "__VITE_ASSET__BsnbB0ao__"